// /client/src/App.js
import './globals.css';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import LoginPage from "./pages/LoginPage";
import ProjectsPage from "./pages/admin/ProjectsPage";
import SkillsPage from "./pages/admin/SkillsPage";
import PublicLayout from './components/PublicLayout';
import HomePage from './pages/public/HomePage';

// Create a basic theme instance.
const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
  {/* --- Public Routes --- */}
  <Route
    path="/"
    element={
      <PublicLayout>
        <HomePage />
      </PublicLayout>
    }
  />

  {/* --- Admin & Auth Routes --- */}
  <Route path="/admin/login" element={<LoginPage />} />
  <Route path="/admin/dashboard" element={<Navigate to="/admin/dashboard/projects" />} />

  <Route
    path="/admin/dashboard/projects"
    element={
      <ProtectedRoute>
        <AdminLayout>
          <ProjectsPage />
        </AdminLayout>
      </ProtectedRoute>
    }
  />

  {/* THIS IS THE CORRECTED ROUTE */}
  <Route
    path="/admin/dashboard/skills"
    element={
      <ProtectedRoute>
        <AdminLayout>
          <SkillsPage />
        </AdminLayout>
      </ProtectedRoute>
    }
  />

  {/* --- Cleanup & Redirects --- */}
  <Route path="/login" element={<Navigate to="/admin/login" />} />
  <Route path="/dashboard" element={<Navigate to="/admin/dashboard" />} />
  <Route path="/dashboard/*" element={<Navigate to="/admin/dashboard" />} />
</Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;